<template>
  <div style="background: #ccc;">
    <div style="width: 840px; margin: auto; background: #fff;">
        <PatientCaseReport :value="$route.params.id"></PatientCaseReport>
    </div>
  </div>
</template>
<script>
import PatientCaseReport from "@/components/Cases/PatientCaseReport";
import { mapMutations } from "vuex";
export default {
  components: {
    PatientCaseReport
  },
  mounted() {
    this.fetchCases();
  },
  methods: {
    ...mapMutations({
      setError: "alert/setError",
      setCase: "pcase/set",
      resetCases: "pcase/reset"
    }),
    async fetchCases() {
      try {
        const response = await this.axios.get(
          `/api/patient-cases/${this.$route.params.id}`
        );
        this.setCase(response.data.data);
      } catch (err) {
        this.setError(err);
      }
    }
  }
};
</script>
<style>
#app {
  position: relative !important;
}
</style>